import { render, staticRenderFns } from "./BasePageStruct.vue?vue&type=template&id=60333678"
import script from "./BasePageStruct.vue?vue&type=script&lang=js"
export * from "./BasePageStruct.vue?vue&type=script&lang=js"
import style0 from "./BasePageStruct.vue?vue&type=style&index=0&id=60333678&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports